//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import defer from '../../mixins/defer';

export default {
  name: 'SlideItems',
  mixins: [defer()],
  props: ['activeIndex', 'marginLeft'],
  data() {
    return {
      isHide: true,
    };
  },
  watch: {
    displayPriority() {
      if (this.displayPriority === 1) {
        this.isHide = false;
      }
    },
  },
};
